
import CustomText, { textStyles } from "../../components/CustomText";
import { Container, Box } from "@mui/material";
import { useState,useMemo } from "react";
import CustomButton from "../../components/CustomButton";
import { useMediaQuery, Grid } from "@mui/material";
import { useTheme, } from "@mui/material/styles";
import pricingunderline from "../../assets/pricingunderline.png"
import PricingCard from "../../components/cards/PricingCard";
import pricingcard1 from "../../assets/pricingcard1.svg";
import pricingcard2 from "../../assets/pricingcard2.svg";
import pricingcard3 from "../../assets/pricingcard3.svg";
import pricingcard4 from "../../assets/pricingcard4.svg"
import { useTranslation } from "react-i18next";
import { useEffect} from "react";
import { BASE_URL } from "../../components/BASE_URL";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const PricingSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };
  // 🔹 Pricing heading/description API state
  const [pricingData, setPricingData] = useState({ title: "", description: "" });
  const [billing, setBilling] = useState('monthly');
  const handleBilling = (e, next) => {
    if (next) setBilling(next);
  };
  const [pricingTitle, setPricingTitle] = useState("");
  const [pricingDesc, setPricingDesc] = useState("");
  const [loading, setLoading] = useState(true);

  const [rawPlans, setRawPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [error, setError] = useState(null);
useEffect(() => {
  async function loadPricing() {
    setLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}/content/sections?page=1&limit=10&sort=order&search=Home_Pricing&include=items`
      );
      const json = await res.json();

      const section = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home_pricing"
      );

      console.log("Pricing Section Full Response:", section);

      if (section?.items?.length) {
        // 🔹 Pick based on current language
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1) // Spanish
            : section.items.find((item) => item.idx === 0); // English

        setPricingData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
        });
      }
    } catch (err) {
      console.error("Error loading pricing section:", err);
    } finally {
      setLoading(false);
    }
  }

  loadPricing();
}, [i18n.language]); // 🔑 re-run when language changes



  // Fetch pricing plans from API
  useEffect(() => {
    async function fetchPlans() {
      try {
        setLoadingPlans(true);
        setError(null);

        const res = await fetch(
          `${BASE_URL}/payments/plans?page=1&limit=105&is_active=true`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );

        if (!res.ok) throw new Error(`Failed: ${res.status}`);

        const json = await res.json();
        const raw = Array.isArray(json?.data?.plans) ? json.data.plans : [];
        const active = raw.filter((p) => p?.is_active === true);

        setRawPlans(active);
      } catch (e) {
        setError(e.message || "Error loading plans");
      } finally {
        setLoadingPlans(false);
      }
    }

    fetchPlans();
  }, []);

  const plans = useMemo(() => {
    const lang = i18n.language === "es" ? "es" : "en";

    return rawPlans.map((p, idx) => {
      const localized = p[lang] || p.en || {};

      return {
        key: p.plan_id || String(idx),
        image: [pricingcard1, pricingcard2, pricingcard3, pricingcard3][idx % 4],
        title: localized.name || p.name || "Plan",
        amount: p.amount,
        billing_cycle: p.billing_cycle,
        currency: p.currency || "USD",
        description: localized.description || "",
        features: Array.isArray(localized.features) ? localized.features : [],
        billing_cycle_label: localized.billing_cycle_label || p.billing_cycle,
        billing_cycle_period: localized.billing_cycle_period || p.billing_cycle,
        duration_type_label: localized.duration_type_label || "",
        link: "",
      };
    });
  }, [rawPlans, i18n.language]);

  // filter visible plans based on billing_cycle
  const visiblePlans = useMemo(
    () => plans.filter((p) => p.billing_cycle === billing),
    [plans, billing]
  );



  const renderHighlightedLastWord = (text) => {
  if (!text) return null;
  const words = text.trim().split(/\s+/);

  return words.map((word, index) => (
    <span
      key={index}
      style={index === words.length - 1 ? { color: "#1e88e5" } : undefined}
    >
      {word}{" "}
    </span>
  ));
};

  return (
    <Box
      sx={{
        marginTop: isMobile ? "20px" : "40px",
        paddingTop: isMobile ? "40px" : "10px",
        paddingBottom: "20px",
        px: isMobile ? 2 : 10,
      }}
    >
      <CustomText
        style={{
          ...textStyles.h1,
          marginBottom: isMobile ? "30px" : "1.2rem",
          marginTop: isMobile ? "0rem" : "1rem",
          fontSize: isMobile ? "38px" : "49px",
        }}
      >
     

        {loading ? (
  <Skeleton height={42} width={isMobile ? 260 : 520} />
) : (
  pricingData.title
    ? renderHighlightedLastWord(pricingData.title)
    : renderHighlightedLastWord(
        `${t("Smart workforce management made")} ${t("affordable")}`
      )
)}

            {/* {loading ? (
          <Skeleton height={42} width={isMobile ? 260 : 520} />
        ) : (
          pricingData.title || `${t("Smart workforce management made")} ${t("affordable")}`
        )} */}

      </CustomText>

      <CustomText
        style={{
          ...textStyles.body1,
          color: "#868282",
          maxWidth: "830px",
          margin: "0 auto",
          marginTop: "15px",
          fontSize: "22px"
        }}
      >
        {/* {t("Save hours on manual tracking and let facial recognition, geolocation, and automated reports handle the hard work for you—no spreadsheets needed.")} */}
       {loading ? (
          <Skeleton height={20} count={2} />
        ) : (
          pricingData.description ||
          t(
            "Save hours on manual tracking and let facial recognition, geolocation, and automated reports handle the hard work for you—no spreadsheets needed."
          )
        )}
      
      </CustomText>
       <Box
        mt={2}
        mb={4}
        sx={{
          display: "flex",
          justifyContent: "center",
          zIndex: 3,
          position: "relative",
        }}
      >
        <Box
          display="flex"
          sx={{
            gap: "8px",
            minWidth: isMobile ? "80px" : "140px",
            border: "1px solid #006EC2",
            borderRadius: "50px",
          }}
        >
          <Box
            onClick={() => setBilling("monthly")}
            sx={{
              px: isMobile ? 2 : 4,
              cursor: "pointer",
              borderRadius: "48px",
              backgroundColor: billing === "monthly" ? "#006EC2" : "none",
         color: billing === "monthly" ? "white" : "#006EC2",  
                     transition: "background-color 0.2s, color 0.2s",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("monthly")}
          </Box>
          <Box
            onClick={() => setBilling("yearly")}
            sx={{
              px: isMobile ? 2 : 3,
              py: isMobile ? 0.5 : 1,
              cursor: "pointer",
              borderRadius: "50px",
              backgroundColor: billing === "yearly" ? "#006EC2" : "white",
         color: billing === "yearly" ? "white" : "#006EC2",  
              transition: "background-color 0.2s, color 0.2s",
              textAlign: "center",
              minWidth: isMobile ? "80px" : "100px",
            }}
          >
            {t("yearly")}
          </Box>
        </Box>
      </Box>

    {/* Pricing Cards Section */}
      <Box
        component="section"
        sx={{
          position: "relative",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: isMobile ? 2 : 2,
          px: isMobile ? 2 : 0,
          zIndex: 3,
          pb: 3,
        }}
      >
        {loadingPlans && <Skeleton height={250} width="80%" />}
        {error && <Box sx={{ color: "red" }}>{error}</Box>}

        {!loadingPlans &&
          visiblePlans.map((plan) => (
            <Box
              key={plan.key}
              sx={{
                // flex: isMobile ? "0 0 100%" : "0 0 calc(26% - 32px)",
                // maxWidth: isMobile ? "100%" : "calc(26% - 32px)",
                flex: isMobile ? "0 0 100%" : "0 0 calc(33% - 24px)",
maxWidth: isMobile ? "100%" : "calc(33% - 24px)",
              }}
            >
              <PricingCard
                imageSrc={plan.image}
                title={plan.title}
                price={`$${Number(plan.amount).toFixed(2)}`}
                priceLabel={`${plan.currency} / ${t("users")} / ${plan.billing_cycle_period}`}
                description={plan.description}
                yearlyHeading={
                  plan.billing_cycle === "yearly" ? plan.billing_cycle_label : ""
                }
                features={plan.features}
                link={plan.link}
  buttonText={t("subscribe_button")}
                             onButtonClick={() => {
  window.location.href = "https://company-admin.biometricpro.app?fromWebsite=true";
}}
                // isHighlighted={plan.highlight}
              />
            </Box>
          ))}
      </Box>
      {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 6, }}>
        <CustomButton label={t('compare_price')} onClick={() => { }} buttonVariant="primary" size="large" />
      </Box> */}
    </Box>
  );
};

export default PricingSection;
